import React, { FC } from 'react';
import DashboardOverview from './components/DashboardOverview';

interface DashboardOverviewScreenProps {}

const DashboardOverviewScreen: FC<DashboardOverviewScreenProps> = () => {
  return <DashboardOverview />;
};

export default DashboardOverviewScreen;
